// extracted by mini-css-extract-plugin
module.exports = {"root":"_c4ca79"};